import { Events } from '@type-r/models';
import { useEvent } from '@type-r/react';
import { AgGridReact } from 'ag-grid-react';
import * as React from 'react';
import { useMemo, useRef } from 'react';
export var GridView = function (_a) {
    var items = _a.items, columnDefs = _a.columnDefs, _b = _a.exportEvent, exportEvent = _b === void 0 ? 'grid:export' : _b;
    // Local state for the grid api, shouldn't render on change.
    var gridApi = useRef(null);
    // Export data on global event 
    useEvent(Events, exportEvent, function () {
        gridApi.current && gridApi.current.exportDataAsCsv();
    });
    // Evaluate columns once on mount.
    var columns = useMemo(columnDefs, [columnDefs]);
    return (React.createElement("div", { className: "ag-theme-balham", style: {
            margin: '8px',
            height: '100%'
        } },
        React.createElement(AgGridReact, { suppressColumnVirtualisation: true, columnDefs: columns, defaultColDef: defaultColDef, rowData: items, onGridReady: function (params) {
                gridApi.current = params.api;
            }, onFirstDataRendered: function (params) {
                params.columnApi.autoSizeAllColumns();
            } })));
};
var defaultColDef = {
    filter: true,
    resizable: true
};
//# sourceMappingURL=gridView.js.map